module.exports = __webpack_public_path__ + "static/img/jyg-02.6f09614.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jyg-02.png
// module id = 152
// module chunks = 1